"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _RangeSliderHandle = _interopRequireDefault(require("./RangeSliderHandle"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var RangeSlider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RangeSlider, _Component);

  function RangeSlider() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RangeSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RangeSlider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_renderRangeSliderHandle", function (handleProps) {
      var _this$props = _this.props,
          currentLabelPrefix = _this$props.currentLabelPrefix,
          currentLabelSuffix = _this$props.currentLabelSuffix;
      delete handleProps.ref;
      return _react.default.createElement(_RangeSliderHandle.default, (0, _extends2.default)({
        prefix: currentLabelPrefix,
        suffix: currentLabelSuffix
      }, handleProps));
    });
    return _this;
  }

  (0, _createClass2.default)(RangeSlider, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          min = _this$props2.min,
          minLabel = _this$props2.minLabel,
          max = _this$props2.max,
          maxLabel = _this$props2.maxLabel,
          step = _this$props2.step,
          defaultValue = _this$props2.defaultValue,
          onChange = _this$props2.onChange,
          onAfterChange = _this$props2.onAfterChange;
      var classes = (0, _classnames.default)('RangeSlider', className);
      var defaultValueOptimized = defaultValue ? defaultValue : Math.round((min + max) / 2);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_rcSlider.default, {
        min: min,
        max: max,
        step: step,
        defaultValue: defaultValueOptimized,
        handle: this._renderRangeSliderHandle,
        onChange: onChange,
        onAfterChange: onAfterChange
      }), minLabel && _react.default.createElement("span", {
        className: "RangeSlider-min-value"
      }, minLabel), maxLabel && _react.default.createElement("span", {
        className: "RangeSlider-max-value"
      }, maxLabel));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return RangeSlider;
}(_react.Component);

exports.default = RangeSlider;
(0, _defineProperty2.default)(RangeSlider, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The minimum value of the slider. */
  min: _propTypes.default.number,

  /** The formatted label text for the minimum value end of the slider. */
  minLabel: _propTypes.default.string,

  /** The maximum value of the slider. */
  max: _propTypes.default.number,

  /** The formatted label text for the maximum value end of the slider. */
  maxLabel: _propTypes.default.string,

  /** The value to be added/subtracted on each step the slider takes. */
  step: _propTypes.default.number,

  /** The default value of the slider. */
  defaultValue: _propTypes.default.number,

  /** The prefix for the slider handle label. */
  currentLabelPrefix: _propTypes.default.string,

  /** The suffix for the slider handle label. */
  currentLabelSuffix: _propTypes.default.string,

  /**
   * Function to execute when the value of the slider is changing during dragging operations.
   *
   * @param {Number} value - The value of the slider handle position.
   */
  onChange: _propTypes.default.func,

  /**
   * Function to execute when the slider is released.
   *
   * @param {Number} value - The value of the slider handle position.
   */
  onAfterChange: _propTypes.default.func
});
(0, _defineProperty2.default)(RangeSlider, "defaultProps", {
  min: 0,
  max: 100,
  step: 1
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RangeSlider, "RangeSlider", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/RangeSlider/RangeSlider.jsx");
  leaveModule(module);
})();

;